import { useCallback, useState } from 'react';

export function useIsOpenState() {
  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  return { open, isOpen, close };
}
